(function() { module.exports = window["jQuery"]; }());